const trainslation = {
  Today: ' Hoy',
  Yesterday: 'Ayer',
  'Last 7 days': 'Last 7 days',
  'Last Week': 'Últimos 7 días',
  'Last 30 days': 'Últimos 30 días',
  'Last Month': ' Mes pasado',

  Uptime: 'Tiempo de actividad',
  Maintanance: 'Maintenance',
  'Unplanned Outages': 'Interrupciones no planificadas',
  'Operational Hours': 'Horas operativas',

  'Prevented Down Time': 'Tiempo de inactividad evitado',
  'Preventive Action Taken': 'Medidas preventivas adoptadas',

  'Total Repair Time': 'Tiempo total de reparación',
  'Number of Incidence': 'Número de incidencias',

  Cases: 'Casos',
  Open: ' Abierta',
  Ongoing: 'En curso',
  Closed: 'Cerrada',
  Incidents: 'Incidentes',
  Requests: 'Requests',

  'Average Throughput': 'Rendimiento promedio',

  'Network Map': ' Mapa de red',
  'Total Sites': ' Total de Sitios DES',
  'Online Sites': 'Sitios en ligne',
  'Degraded Sites': 'Sitios degradados',

  Events: 'Eventos',
}

export default trainslation
